import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MaskedInput from 'react-text-mask';
import { Typography } from '@material-ui/core';
import DynamicTitle from "../../component/DynamicTitle";
import TemplateComponent from "../../component/template/TemplateComponent";
import { UserInfoModel } from "../../models/UserInfoModel";
import { RootState } from "../../store";
import { actions as UserAction } from "../../store/redux/UserInfoRedux";
import { NavTo } from "../../utils/AppManager";
import { nationalIdMask, Path } from "../../utils/Constant";
import { defaultHeight, fontUnit, heightUnit, padGinUnit } from "../../utils/DeviceManager";
import { isCitizenId } from "../../utils/SecureManager";
import { AcnColorTheme } from "../../assets/css/AcnColorTheme";
import { Service } from "../../service/ServiceApi";
import { makeStyles } from "@material-ui/styles";
const iOS = require('is-ios');

export function NationalIdScreen() {

    const classes = useStyles();
    const dispatch = useDispatch();
    const [userInfo] = useSelector((state: RootState) => [
        state.userInfoReducer.userInfo
    ]);

    const [nationalId, setNationalId] = useState("")

    useEffect(() => {
        document.title = "สมัครใช้งาน\u200E\u200E\u200E\u200E\u200E"
        if (userInfo.nationalId) {
            setNationalId(userInfo.nationalId)
        }
    }, [userInfo.nationalId]);

    const isValidNationalId = () => {
        return isCitizenId(nationalId);
    };

    const onConfirm = () => {
        if (isValidNationalId()) {
            const newInfo: UserInfoModel = { ...userInfo, nationalId: nationalId }
            UserAction.setUserInfo(dispatch, newInfo).then(() => {
              NavTo(Path.consent)
            })
        }
    }

    const nationalIdWidget = () => {
        return (
            // <div style={{position: 'fixed', overflow: "hidden", marginTop: !iOS? '-18px':''}}>
            <div style={{ position: 'fixed', overflow: "hidden", marginRight: '20px' }}>
                {/* <div style={{height: heightUnit(defaultHeight*0.82), overflowY: 'auto', overflowX: 'hidden'}}> */}
                <div style={{ height: heightUnit(defaultHeight * 0.9), overflowY: 'auto' }}>
                    <DynamicTitle title={"กรุณากรอกเลขประจำตัวประชาชน"} size={fontUnit(24)} isFull={true} align={"left"} />
                    <MaskedInput
                        onChange={({ currentTarget }) => {
                            const value = currentTarget.value
                            setNationalId(value.replaceAll('-', ''));
                        }}
                        mask={nationalIdMask}
                        placeholder="เลขประจำตัวประชาชน 13 หลัก"
                        guide={false}
                        className={classes.customPlaceholderStyle}
                        id="citizenid"
                        onKeyPress={event => {
                            if (event.key === 'Enter') {
                                onConfirm()
                            }
                        }}
                        style={{
                            width: "95%", height: heightUnit(56), minHeight: 42,
                            borderRadius: 8, marginTop: 40,
                            outline: "none", fontSize: fontUnit(18), paddingLeft: padGinUnit(8),
                            border: '1px solid #E3E5E8', colorAdjust: "inherit",
                            fontFamily: 'Prompt-Medium'
                        }}
                        type="tel"
                        autoComplete="off"
                        aria-labelledby="InputLabel"
                        aria-required="false"
                        defaultValue={nationalId}
                        autoFocus
                        required
                    />
                    <Typography
                        align={"left"}
                        style={{ fontFamily: "Thonburi", fontSize: fontUnit(16), marginTop: padGinUnit(12), fontWeight: "normal", color: AcnColorTheme.black }}>
                        โปรดอ่านเพิ่มเติมเกี่ยวกับประกาศนโยบาย ความเป็นส่วนตัวของเราอย่างละเอียด เพื่อเข้าใจถึงวิธีการที่เราเก็บรวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคลของคุณและสิทธิของคุณ&nbsp;
                        <a href={Service.CHAIYO_WEB + "policy-page"}>ที่นี่</a>
                    </Typography>
                    <div style={{ height: !iOS ? '240px' : '' }} />
                    {/* <div style={{height: '200px'}} /> */}
                </div>
            </div>
        )
    };


    return (
        <TemplateComponent content={nationalIdWidget()}
            onNext={onConfirm}
            isCanNext={isValidNationalId()}
            nextText={"ยืนยัน"} />
    );
}

const useStyles = makeStyles(() => ({
  
    customPlaceholderStyle: {
        '&::placeholder': {
          color: '#BCC1C7'
        },
    }
}))